import { render, staticRenderFns } from "./CollapseOptions.vue?vue&type=template&id=b71fe250&"
import script from "./CollapseOptions.vue?vue&type=script&lang=ts&"
export * from "./CollapseOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCollapseTransition: require('/home/vsts/work/1/a/NuxtApp/components/base/CollapseTransition.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default})
